import { IconInfo } from '../Icons';

export const Info = ({ info }: { info: string }) => {
    return (
        <div className="flex items-start space-x-1">
            <div className="fw-svg flex-shrink-0 w-4 h-auto text-neutral-500 mt-px">
                <IconInfo />
            </div>
            <div className="text-sm">{info}</div>
        </div>
    );
};
